<template>
    <tableView
        :assessSchemeApproval="true"
        :selectable="selectable"
        :template-info="templateInfo"
        :send-verify="true"
        :send-verify-url="sendVerifyUrl"
        check-selectablefield="status"
    />
</template>

<script>
  import axios from "axios";
  import tableView from "@/components/tableView.vue";
  export default {
    name: "assess-approval",
    components:{
      tableView
    },
    data(){
      return {
        selectable:true,
        templateInfo: {},
        tabList:[],
        sendVerifyUrl:process.env.VUE_APP_SERVER + "/dataprovider/businessdata/assess/submitToVerify"
      }
    },
    mounted(){
      this.knowThis();
    },
    methods:{
      async knowThis() {
        let _this = this;
        console.log(this.$route.name)
        let localIpStr = localStorage.getItem("userLocalIP");
        if (localIpStr == null) localIpStr = "127.0.0.1";
        let jwtSession = localStorage.getItem("lyqtJwt");
        if (jwtSession == null) jwtSession = "";
        await axios({
          url:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module/route/template/" + `${this.$route.name}`,
          headers: {
            "Authorization": "Bearer " + jwtSession,
            "userIP": localIpStr
          },
          method: 'GET'})
          .then(res => {
            console.log("template",res.data.content);
            console.log(res.data.content)
            _this.tabList=res.data.content;
            _this.templateInfo = _this.tabList.pages[0];
            _this.templateInfo.moduleid=_this.tabList.moduleid;
            _this.templateInfo.modulename=_this.tabList.modulename;
          }).catch(err => {
            console.log(err)
          })
      },
    }
  }
</script>

<style scoped>

</style>